<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('utils.lunlog36')"
      @backurl="$router.back()"
    />
    <div class="block_div auth_wrap">
      <form
        class="form"
        @submit.prevent="submit"
      >
        <!-- <div class="tittle_verified">
					{{$t('utils.lunlog36')}}
				</div> -->
        <!-- div class="tittle_verified_tips">
					{{$t('utils.lunlog37')}}
				</div> -->
        <div class="item">
          <input
            v-model.trim="username"
            type="text"
            class="inp"
            :placeholder="$t('login.username')"
          >
        </div>
        <div class="item">
          <input
            v-model.trim="email"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailEmpty')"
          >
        </div>
        <div class="item">
          <input
            v-model.trim="code"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailCode')"
          >
          <van-count-down
            :time="time"
            class="btn get_captcha"
            style="line-height: 40px;"
            @finish="timeCall"
          >
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0
                  ? timeData.seconds
                  : $t('auth.sendEmailCode')
              }}</span>
            </template>
          </van-count-down>
        </div>
        <div class="item">
          <input
            v-model.trim="newpwd"
            type="password"
            class="inp"
            :placeholder="$t('utils.lunlog20')"
          >
        </div>
        <div class="item">
          <input
            v-model.trim="conpwd"
            type="password"
            class="inp"
            :placeholder="$t('utils.lunlog23')"
          >
        </div>
        <button
          style=" color: #fff;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: .4px;
    background: #e50914"
          type="submit"
          class="basic_btn sbtn"
          :class="email==''||code==''?'no_touch':''"
        >
          {{ $t('utils.confirm') }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		CountDown,
		Checkbox
	} from "vant";
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	Vue.use(CountDown)
		.use(Checkbox);
	export default {
		name: "Pwd",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				time: 0,
				email: '',
				username:'',
				pwd:'',
				code: '',
				oldpwd:'',
				newpwd:'',
				conpwd:'',
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FFFFFF');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('user', false);
		},
		mounted() {
			
		},
		methods: {
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return false;
				}
				if (!this.email) {
					this.$toast(this.$t('auth.emailEmpty'));
					return false;
				}
				if (!this.username) {
					this.$toast(this.$t('login.usernameEmpty'));
					return false; 
				}
				if (this.username.length > 16 || this.username.length < 4) {
					this.$toast(this.$t('login.usernameLength'));
					return false;
				}
				var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				if (!reg.test(this.email)) {
					this.$toast(this.$t('auth.emailError'));
					return false;
				}
				this.is_send = true;

				Fetch("/index/getEmailCode", {
					email: this.email,
					username:this.username
				}).then(() => {
					this.time = 60 * 1000;
					this.$toast({
						background: "#07c160",
						message: this.$t('auth.sendsuccess'),
					});
				}).catch(() => {
					this.is_send = false;
				});
			},
			submit() {
				// if (!this.email) {
				// 	this.$toast(this.$t('auth.emailEmpty'));
				// 	return false;
				// }
				// var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				// if (!reg.test(this.email)) {
				// 	this.$toast(this.$t('auth.emailError'));
				// 	return false;
				// }
				// if (!this.code) {
				// 	this.$toast(this.$t('auth.codeEmpty'));
				// 	return false;
				// }
				// if (!this.oldpwd) {
				// 	this.$toast(this.$t('utils.lunlog22'));
				// 	return false;
				// }
				if (!this.newpwd) {
					this.$toast(this.$t('utils.lunlog20'));
					return false;
				}
				if (!this.conpwd) {
					this.$toast(this.$t('utils.lunlog23'));
					return false;
				}
				if (this.newpwd != this.conpwd) {
					this.$toast(this.$t('utils.lunlog24'));
					return false;
				}
				// if (this.newpwd == this.oldpwd) {
				// 	this.$toast(this.$t('utils.lunlog25'));
				// 	return false;
				// }
				
				Fetch('/index/pwd', {
					oldpwd: this.oldpwd,
					newpwd: this.newpwd,
					conpwd: this.conpwd,
					username:this.username,
					email:this.email,
					code:this.code
				}).then(r => {
						if(r.code=='218'){
							this.$toast(this.$t(r.info));return false;
						}else{
							this.$toast({
								background: '#07c160',
								message: this.$t('utils.lunlog37')
							});
							this.$router.replace('/user')
						}
					})
			},
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap{
		position: relative;
		overflow: hidden;
		min-height: 100vh;
		background-color: var(--bg-primary);
		color: var(--text-primary);

	}
	.auth_wrap {
		margin-top: 100px;
		padding: 18px 15px;
		background: linear-gradient(155deg, hsla(0, 0%, 100%, .96), rgba(246, 250, 255, .94) 55%, rgba(236, 246, 255, .9));
		border: 1px solid rgba(176, 202, 240, .55);
		border-radius: 18px;
		box-shadow: 0 18px 34px rgba(24, 61, 122, .12), inset 0 1px 0 hsla(0, 0%, 100%, .9);
		
	}

	.auth_1 {
		text-align: center;
		margin-top: 50%;

		p {
			margin-top: 40px;
			font-size: 20px;
			color: green;
			font-weight: bold;
		}
	}

	.tittle_verified {
		margin-top: 10px;
		margin-bottom: 20px;
		font-size: 26px;
	}

	.tittle_verified_tips {
		line-height: 1.5;
	}

	.form {
		width: 100%;
		// margin-top: 65px;
		

		.item {
			height: 40px;
			font-size: 14px;
			display: flex;
			justify-content: flex-start;
			align-items: flex-end;
			padding-bottom: 4px;
			margin-bottom: 20px;
			color: #1a2742;
			border-radius: 12px;
			padding: 0 0px 0px 15px;
			background: rgba(248, 252, 255, .95);
			border: 1px solid #d8e6fb;
			transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;

			input {
				height: 40px;
				flex: 1;
				color: #1a2742;
				&::placeholder {
					color: #000;
				}
			}
		}
	}
	.btn{
		
	}
	.sbtn {
		margin-top: 10px;
	}
	.van-count-down{
		line-height:40px;
		color:#fff;
		margin-right: 0px;
		padding: 0 10px;
		background:#e50914;
		border-radius: 12px;
	}
</style>
